// extracted by mini-css-extract-plugin
export var labelPadding = "index-module--labelPadding--3CjLE";
export var labelText = "index-module--labelText--3pj0z";
export var container = "index-module--container--1pqM0";